import { gql } from '@apollo/client';

export const programManagerQuery = gql`
  query ProgramManager($id: ID!) {
    programManager(id: $id) {
      id
      name
      payfac
      merchantDomain
      adminDomain
      website
      theme {
        logo
        icon
        primaryColor
        secondaryColor
      }
      merchantCompanies {
        id
      }
      metaProgramManager {
        id
        name
        theme {
          icon
          secondaryColor
        }
      }
    }
  }
`;

export const removeProgramManagerMutation = gql`
  mutation RemoveProgramManager($id: ID!) {
    removeProgramManager(id: $id) {
      id
    }
  }
`;
